import React, { FC } from "react";
import { Button, ButtonProps, Tooltip } from "antd";
import { CoordinapeIcon } from "@dewo/app/components/icons/Coordinape";

export const CoordinapeToAdminPanelButton: FC<ButtonProps> = (buttonProps) => (
  <Tooltip
    title={`Open "Settings" in the Coordinape Circle Admin page to connect Dework`}
  >
    <Button
      icon={<CoordinapeIcon />}
      href="https://app.coordinape.com/admin"
      target="_blank"
      name="Connect Coordinape integration"
      {...buttonProps}
    >
      Connect to Coordinape
    </Button>
  </Tooltip>
);
